import { Interval } from 'luxon';

import {
  IntervalHeadcountCount,
  ReservationWithHeadcount,
} from './types';

type IntermediateReturn = {
  [key: string]: IntervalHeadcountCount;
};

const intervalKey = (i: Interval) =>
  `${i.start.valueOf()}_${i.end.valueOf()}`;

export function countIntervalIntersectionsWithHeadcount(
  reservations: ReservationWithHeadcount[],
  ret: IntermediateReturn = {},
  carriedCount?: number
): IntervalHeadcountCount[] {
  for (const reservation of reservations) {
    let intersects = false;

    for (const k of Object.keys(ret)) {
      const retInterval = ret[k].interval;
      const retEventType = ret[k]?.eventType || null;
      const intersection = retInterval.intersection(reservation.interval);

      if (
        intersection &&
        !retInterval.abutsEnd(reservation.interval) &&
        !retInterval.abutsStart(reservation.interval)
      ) {
        intersects = true;

        const existingCount = ret[k].count;
        const leftover = retInterval
          .difference(reservation.interval)
          .map(i => ({
            interval: i,
            eventType: retEventType,
            headcount: existingCount,
          }));
        const unfinishedBusiness = reservation.interval
          .difference(retInterval)
          .map(i => ({
            interval: i,
            eventType: retEventType,
            headcount: reservation.headcount,
          }));

        delete ret[k];
        ret[intervalKey(intersection)] = {
          interval: intersection,
          count: existingCount + reservation.headcount,
          eventType: reservation.eventType,
        };
        countIntervalIntersectionsWithHeadcount(leftover, ret, existingCount);
        countIntervalIntersectionsWithHeadcount(unfinishedBusiness, ret);

        break;
      }
    }

    if (!intersects) {
      ret[intervalKey(reservation.interval)] = {
        interval: reservation.interval,
        count: carriedCount ?? reservation.headcount,
        eventType: reservation.eventType,
      };
    }
  }

  return Object.values(ret).sort(
    (a, b) => a.interval.start.valueOf() - b.interval.start.valueOf()
  );
}
